import { ProductBlock } from '@/organisms';
import { Container } from '@/atoms';
import { CardBlog, SliderProduct } from "@/molecules";
import { Size, Variation } from '@/molecules/card-blog/types';
import { LinkVariant } from '@/atoms/link/types';
import { getUrlFromMedia } from "@/utils/utils";

export function BlockRecipes({ view, title }: any) {
    return (
        <Container backgroundColor="bg-bg-quinary" wrapper>
            <ProductBlock
                title={title}
            >
                <SliderProduct className='w-full'
                    breakpoints={{
                        500: {
                            padding: 45,
                            perPage: 1,
                        },
                        768: {
                            padding: 45,
                            perPage: 2,
                        },
                        1024: {
                            perPage: 3,
                        },
                    }}
                    perPage={3}>
                    {view?.map((itm: { field_image: { field_media_image: any; }; title: string | null | undefined; path: { alias: string; }; }, index: number) => (
                        <CardBlog
                            key={`card-blog-${index}`}
                            image={{
                                src: getUrlFromMedia(itm.field_image),
                                alt: itm.field_image.field_media_image.resourceIdObjMeta.alt,
                            }}
                            size={Size.LARGE}
                            variation={Variation.DISPLAY}
                        >
                            <CardBlog.Pretitle key="0" position="left">
                                Recetas
                            </CardBlog.Pretitle>
                            ,<CardBlog.Title key="1">{itm.title}</CardBlog.Title>,
                            <CardBlog.Link
                                href={itm.path.alias}
                                variant={LinkVariant.NEGATIVE}
                                key="2"
                            >
                                Leer
                            </CardBlog.Link>
                        </CardBlog>
                    ))}
                </SliderProduct>
            </ProductBlock>
        </Container>
    )
}


